export default "__VITE_ASSET__DRGU_99s__"